import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { SettingsDescription } from '@/pages/account/components/settings-description'
import { SettingsForm } from '@/pages/account/components/settings-form'

export const SettingsRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <>
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="common.controls.settings" />
      </Typography>
      <div className="flex gap-6 sm:flex-col">
        <div className="flex-[1_0_48%]">
          <SettingsForm />
        </div>

        <div className="flex-[1_1_48%]">
          <SettingsDescription />
        </div>
      </div>
    </>
  )
}
